import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

if ('serviceWorker' in navigator) {
  const baseHref = document.querySelector('base')?.getAttribute('href') || '/';
  console.log("🚀 ~ baseHref:", baseHref)
  let resolvedBase = baseHref;
  if (resolvedBase === '/' && window.location.pathname && window.location.pathname !== '/') {
    const segments = window.location.pathname.split('/').filter(Boolean);
    if (segments.length > 0) {
      resolvedBase = `/${segments[0]}/`;
    }
  }
  const normalizedBase = resolvedBase.endsWith('/') ? resolvedBase : `${resolvedBase}/`;
  console.log("🚀 ~ normalizedBase:", normalizedBase)
  navigator.serviceWorker.register(`${normalizedBase}firebase-messaging-sw.js`).catch(err =>
    console.error('Service worker registration failed', err)
  );
}
